import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import MidiEffects from "components/mix/mix2/MidiEffects.js";

const SubMidiEffectsComponent = ({sequencerEngine, subSequence}) => { 
    return (
        <div className="sends midi track">
          <div className="track-container">
            <div className="track-header">
              <div className="track-name-view">
                Midi FX
              </div>
            </div>
            <div className="sends-container">
              <MidiEffects sequencerEngine={sequencerEngine} track={subSequence}/>
            </div>
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      subSequence: props.sequencerEngine.currentSubSequence
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubMidiEffectsComponent);
